export default __webpack_public_path__ + "static/media/MirrorIcon.83bfa4de.svg";